import { isMobileBrowser } from '@/utils/common/device';
import Trans from 'next-translate/Trans';
import { FC, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { CardType, ProductCardProps } from '../../types';
import CardBodyBottomInfo from './card-body-bottom-info';
import CardBodyMetrics from './card-body-metrics';
import CardBodyMkplEta from './card-body-mkpl-eta';
import CardBodyMkplShip from './card-body-mkpl-ships';
import CardBodyPreSale from './card-body-pre-sale';
import CardBodyPrice from './card-body-price';
import CardBodyProductName from './card-body-product-name';
import CardBodyLinkedTag from './card-body-linked-tag';
import CardBodyTopTag from './card-body-top-tag';
import CardBodyPredictDeliveryDate from './card-body-predict-delivery-date';
import ProductClaimedPriority from './product-claimed-priority';

const CardBodyHorizontal: FC<
  Partial<ProductCardProps> & CardType & { midBoxClass?: string; priceLineSlot?: React.ReactNode }
> = props => {
  const { showExtraTag, data, midBoxClass, priceLineSlot } = props;
  const [isPc, setIsPc] = useState<boolean>(false);

  useEffect(() => {
    // 直接取值会出水合问题
    setIsPc(!isMobileBrowser());
  }, []);

  return (
    <div
      data-role="mid-box"
      className={twMerge('flex flex-col self-stretch justify-between ml-2 overflow-hidden', midBoxClass)}>
      <div>
        <CardBodyTopTag {...props} className="mb-1" />
        <CardBodyProductName {...props} cardType={props?.cardType} />
        <CardBodyMetrics {...props} />
        <CardBodyBottomInfo {...props} className="mx-0 mt-1" cardType="horizontal" />
      </div>

      <div>
        {showExtraTag && !!+data?.discount_percentage && (
          <span className="text-[10px] inline-block px-1 h-5 leading-5 mt-0 mb-1 rounded bg-orange-200 font-semibold text-center text-orange-600">
            <Trans
              i18nKey="common:order_share_grocery_extra_tag"
              components={{
                span: <span />
              }}
              values={{
                discount: data?.discount_percentage
              }}
            />
          </span>
        )}
        <div className="flex items-center justify-between w-full">
          <CardBodyPrice {...props} className={!!priceLineSlot ? 'my-0' : ''} />
          {priceLineSlot}
        </div>

        <ProductClaimedPriority {...props} />

        {/* max-width: 150px在宽度375的屏幕上还是会遮挡 */}
        <CardBodyPreSale {...props} />
        <CardBodyMkplEta {...props} className={twMerge('my-0.5 max-w-[138px]', isPc && 'max-w-full')} />
        <CardBodyMkplShip {...props} className={twMerge('my-0.5 max-w-[138px]', isPc && 'max-w-full')} />
        <CardBodyLinkedTag {...props} />
        <CardBodyPredictDeliveryDate {...props} className="my-0.5" />
      </div>
    </div>
  );
};
export default CardBodyHorizontal;
